module.exports = __webpack_public_path__ + "img/calapan-periodical1.246e671d.jpg";